/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adddate1Inputs */

const en_adddate1 = /** @type {(inputs: Adddate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add date`)
};

const de_adddate1 = /** @type {(inputs: Adddate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termin hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add date" |
*
* @param {Adddate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const adddate1 = /** @type {((inputs?: Adddate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adddate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adddate1(inputs)
	return de_adddate1(inputs)
});
export { adddate1 as "addDate" }